import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/vexubweb/app/[locale]/(blog)/blog/components/ArticleListPaginated.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/app/[locale]/css/style.css");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/html/vexubweb/public/images/logovexub.png");
